export const TOOLTIP_PROPS: {
    delay?: number;
    class?: string;
    anchor?:
        | 'top left'
        | 'top middle'
        | 'top right'
        | 'top start'
        | 'top end'
        | 'center left'
        | 'center middle'
        | 'center right'
        | 'center start'
        | 'center end'
        | 'bottom left'
        | 'bottom middle'
        | 'bottom right'
        | 'bottom start'
        | 'bottom end';
    self:
        | 'top left'
        | 'top middle'
        | 'top right'
        | 'top start'
        | 'top end'
        | 'center left'
        | 'center middle'
        | 'center right'
        | 'center start'
        | 'center end'
        | 'bottom left'
        | 'bottom middle'
        | 'bottom right'
        | 'bottom start'
        | 'bottom end';
    offset?: number[];
} = {
    delay: 400,
    class: 'text-body2 text-white',
    anchor: 'bottom start',
    self: 'center start',
    offset: [0, 20]
};
